import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/(policies)/cgv")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="max-container mt-10 mx-auto px-4 font-outfit">
      <h1 className="font-bold text-[#17365d] text-5xl max-md:text-2xl mb-5">
        Conditions Générales de Vente (CGV) de HomeToq
      </h1>
      <hr className="h-0.5 bg-dark-blue rounded-full mb-5" />

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Préambule</h2>
        <p>
          HomeToq SAS est une société par actions simplifiée au capital de 10
          000 euros immatriculée au registre du commerce et des sociétés de
          Perpignan sous le numéro 927 511 287, dont le siège social est situé
          au 6 Rue des Potiers, 66240 Saint-Estève, France. La plateforme
          HomeToq propose un service de mise en relation entre des chefs à
          domicile et des clients pour des prestations culinaires.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 1 : Définitions
        </h2>
        <p>
          Dans le cadre des présentes CGV, les termes et expressions identifiés
          par une majuscule ont les significations suivantes, sauf si le
          contexte exige une interprétation différente : <br />-{" "}
          <strong>&ldquo;La Société&rdquo;</strong> désigne HomeToq SAS. <br />-{" "}
          <strong>&ldquo;Le Prestataire&rdquo;</strong> se réfère à tout chef à
          domicile utilisant la plateforme HomeToq pour proposer ses services
          culinaires aux clients. <br />-{" "}
          <strong>&ldquo;Plateforme&rdquo;</strong> désigne le site
          <br />
          internet exploité par la Société accessible à l&apos;adresse
          www.hometoq.com, incluant toutes ses versions mobiles et applications
          dérivées. <br />- <strong>&ldquo;Services&rdquo;</strong> se réfère
          aux prestations culinaires proposées par le Prestataire à travers la
          Plateforme. <br />- <strong>&ldquo;Utilisateurs&rdquo;</strong>{" "}
          désigne les clients utilisant la Plateforme pour rechercher, comparer
          et réserver les Services offerts par les Prestataires. <br />-{" "}
          <strong>&ldquo;Réservation&rdquo;</strong> signifie l&apos;acte par
          lequel un Utilisateur s&apos;engage à acheter des Services auprès
          d&apos;un Prestataire via la Plateforme. <br />-{" "}
          <strong>&ldquo;Commission&rdquo;</strong> désigne la rémunération due
          à la Société par le Prestataire calculée en pourcentage du prix des
          Services réservés via la Plateforme.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 2 : Objet des CGV
        </h2>
        <p>
          Les présentes CGV régissent la relation entre la Société, les
          Prestataires (chefs à domicile) et les Utilisateurs utilisant la
          Plateforme pour réserver des Services culinaires.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 3 : Modalités de Réservation
        </h2>
        <p>
          3.1 <strong>Processus de Réservation</strong> <br />
          Les Utilisateurs effectuent une Réservation en suivant les étapes
          suivantes : <br />
          - Sélectionner le type de prestation souhaitée. <br />
          - Choisir un Prestataire disponible. <br />- Confirmer les détails de
          la prestation (date, menu, prix, etc.). <br />
          - Effectuer le paiement sécurisé via la Plateforme. <br />
          <br />
          3.2 <strong>Confirmation de Réservation</strong> <br />
          La Réservation est considérée comme définitive lorsque le Prestataire
          accepte la demande de l&apos;Utilisateur et que le paiement est
          validé. <br />
          <br />
          3.3 <strong>Modification ou Annulation de Réservation</strong> <br />
          Toute modification ou annulation doit se faire en conformité avec les
          modalités prévues à l&apos;article 7 des présentes CGV.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 4 : Engagements de la Société
        </h2>
        <p>
          4.1 <strong>Promotion des Services</strong> <br />
          La Société s&apos;engage à promouvoir activement les Services des
          Prestataires via différents canaux de marketing, y compris les réseaux
          sociaux et la publicité en ligne. <br />
          <br />
          4.2 <strong>Support Technique</strong> <br />
          La Société fournit un support technique continu pour aider les
          Prestataires dans l&apos;utilisation optimale de la Plateforme.
          <br />
          4.3 <strong>Gestion des Transactions Financières</strong> <br />
          La Société est responsable de la collecte des paiements effectués par
          les Utilisateurs. Les montants dus aux Prestataires sont versés après
          déduction de la Commission.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 5 : Engagements des Prestataires
        </h2>
        <p>
          5.1 <strong>Respect des Normes</strong> <br />
          Les Prestataires s&apos;engagent à fournir des Services conformes aux
          descriptions fournies sur la Plateforme, en respectant les normes
          sanitaires et de sécurité. <br />
          <br />
          5.2 <strong>Mise à Jour des Informations</strong> <br />
          Les Prestataires doivent maintenir à jour les informations relatives à
          leur disponibilité, leurs menus et leurs tarifs sur la Plateforme.{" "}
          <br />
          <br />
          5.3 <strong>Gestion des Réservations</strong> <br />
          Les Prestataires sont responsables d&apos;accepter ou de refuser les
          Réservations de manière prompte et professionnelle.
        </p>
        <br />
        <br />
      </div>

      {/* Additional Sections */}
      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 6 : Modalités Financières
        </h2>
        <p>
          6.1 <strong>Structure de Rémunération</strong> <br />
          Le Prestataire accepte que la Société prélève une Commission d&apos;un
          montant en TTC convenu au préalable. <br />
          <br />
          6.2 <strong>Facturation et Paiements</strong> <br />
          Le montant net dû au Prestataire après déduction de la Commission sera
          versé dans un délai de 30 jours suivant la complétion de la
          prestation. <br />
          <br />
          6.3 <strong>Modifications des Conditions Financières</strong> <br />
          Toute modification des taux de Commission sera communiquée au
          Prestataire avec un préavis d&apos;au moins 30 jours.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 7 : Modalités de Remboursement et Annulation
        </h2>
        <p>
          7.1 <strong>Annulation par l&apos;Utilisateur</strong> <br />-{" "}
          <strong>Plus de 72 heures avant la prestation :</strong> Remboursement
          intégral (100 %). <br />-{" "}
          <strong>Entre 72 et 48 heures avant la prestation :</strong>{" "}
          Remboursement de 50 %. <br />-{" "}
          <strong>Moins de 48 heures avant la prestation :</strong> Aucun
          remboursement. <br />
          <br />
          7.2{" "}
          <strong>
            Annulation pour les Prestations de Plus de 1 250 Euros
          </strong>{" "}
          <br />- <strong>0 à 7 jours avant la prestation :</strong> Aucun
          remboursement. <br />-{" "}
          <strong>7 à 14 jours avant la prestation :</strong> Remboursement de
          50 %. <br />- <strong>Plus de 14 jours avant la prestation :</strong>{" "}
          Remboursement intégral (100 %). <br />
          <br />
          7.3 <strong>Annulation par le Prestataire</strong> <br />
          Si un Prestataire annule une prestation confirmée, la Plateforme
          s'efforcera de trouver un autre chef qualifié pour répondre à la
          demande initiale de l'Utilisateur. Si aucun remplaçant
          n&apos;est trouvé, l&apos;Utilisateur sera remboursé intégralement.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 8 : Durée et Résiliation
        </h2>
        <p>
          8.1 <strong>Durée du Contrat</strong> <br />
          Le présent contrat est conclu pour une durée indéterminée à compter de
          la date de signature par les deux parties. <br />
          <br />
          8.2 <strong>Résiliation par le Prestataire</strong> <br />
          Le Prestataire peut résilier ce contrat avec un préavis écrit de 30
          jours. <br />
          <br />
          8.3 <strong>Résiliation par la Société</strong> <br />
          La Société peut résilier ce contrat avec un préavis écrit de 30 jours.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 9 : Propriété Intellectuelle
        </h2>
        <p>
          9.1 <strong>Droits de Propriété Intellectuelle du Prestataire</strong>{" "}
          <br />
          Le Prestataire conserve tous les droits de propriété intellectuelle
          sur ses recettes, photos, vidéos, textes et tout autre matériel fourni
          à la Plateforme. <br />
          <br />
          9.2 <strong>Utilisation des Marques</strong> <br />
          Le Prestataire est autorisé à utiliser les marques et logos de HomeToq
          uniquement dans le cadre de la promotion de ses Services via la
          Plateforme. <br />
          <br />
          9.3 <strong>
            Droits de Propriété Intellectuelle de la Société
          </strong>{" "}
          <br />
          La Société conserve tous les droits de propriété intellectuelle sur la
          Plateforme HomeToq.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 10 : Confidentialité
        </h2>
        <p>
          10.1 <strong>Définition des Informations Confidentielles</strong>{" "}
          <br />
          Les Informations Confidentielles incluent toutes les données et
          informations divulguées par une partie à l&apos;autre pendant la durée
          du contrat. <br />
          <br />
          10.2 <strong>Obligations de Confidentialité</strong> <br />
          Les parties s&apos;engagent à ne pas divulguer les Informations
          Confidentielles à des tiers sans le consentement préalable écrit de la
          partie divulgatrice. <br />
          <br />
          10.3 <strong>
            Durée de l&apos;Obligation de Confidentialité
          </strong>{" "}
          <br />
          Les obligations de confidentialité subsisteront pendant cinq (5) ans
          après la résiliation ou l&apos;expiration du contrat.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 11 : Indemnisation
        </h2>
        <p>
          Le Prestataire s&apos;engage à indemniser et dégager de responsabilité
          la Société contre toutes pertes résultant de violations du contrat ou
          de comportements illégaux ou négligents.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 12 : Limitation de Responsabilité
        </h2>
        <p>
          12.1 <strong>Limitation des Dommages</strong> <br />
          La Société ne sera en aucun cas responsable envers le Prestataire pour
          toute perte de profits, de revenus ou pour tout dommage indirect.{" "}
          <br />
          <br />
          12.2 <strong>Plafonnement de la Responsabilité</strong> <br />
          La responsabilité totale de chaque partie ne dépassera pas le montant
          total des paiements versés ou dus au Prestataire sous ce contrat
          pendant les 12 mois précédant l&apos;événement.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 13 : Règlement des Litiges
        </h2>
        <p>
          13.1 <strong>Médiation</strong> <br />
          Avant d&apos;engager toute procédure judiciaire, les parties
          s&apos;engagent à tenter de résoudre tout litige par la médiation.{" "}
          <br />
          <br />
          13.2 <strong>Procédure Judiciaire</strong> <br />
          Si la médiation échoue, les parties peuvent soumettre le litige à la
          juridiction compétente.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Article 14 : Dispositions Générales
        </h2>
        <p>
          14.1 <strong>Modifications des CGV</strong> <br />
          Toute modification des présentes CGV doit être faite par écrit et
          signée par les deux parties. <br />
          <br />
          14.2 <strong>Intégralité du Contrat</strong> <br />
          Ces CGV constituent l&apos;intégralité de l&apos;accord entre les
          parties. <br />
          <br />
          14.3 <strong>Loi Applicable et Juridiction</strong> <br />
          Ces CGV sont régies par le droit français. Tout litige sera soumis à
          la juridiction exclusive des tribunaux compétents de Perpignan.
        </p>
      </div>
    </section>
  );
}
